import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileDrawer } from './MobileDrawer';
const SIDEBAR_COLLAPSED_KEY = 'hodito-sidebar-collapsed';
function getSidebarCollapsed() {
    if (typeof window === 'undefined')
        return false;
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
}
export const Layout = ({ children, pageTitle, activePage, actions }) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(getSidebarCollapsed);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const toggleSidebar = () => {
        const next = !sidebarCollapsed;
        setSidebarCollapsed(next);
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(next));
    };
    return (_jsxs("div", { className: "min-h-screen bg-background", children: [_jsx(Sidebar, { activePage: activePage, collapsed: sidebarCollapsed, onToggleCollapse: toggleSidebar }), _jsx(MobileDrawer, { isOpen: mobileMenuOpen, onClose: () => setMobileMenuOpen(false), activePage: activePage }), _jsxs("div", { className: `flex flex-col min-h-screen transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-[68px]' : 'lg:ml-[260px]'}`, children: [_jsx(Header, { pageTitle: pageTitle, onOpenMobileMenu: () => setMobileMenuOpen(true), actions: actions }), _jsx("main", { className: "flex-1 p-4 lg:p-6", children: _jsx("div", { className: "animate-fade-in", children: children }) }), _jsx(Footer, {})] })] }));
};
